import axios from "axios";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import Slider from "react-slick";
import { serverInfo } from "../../../../../../../../App";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import RegisteredTable from "./RegisteredTable";
import "./RegisterUserListAudition.css";

import cup from "../../../../../../../../assets/images/cup 2.png";
import Nodata from "../../../../../../../Reuseable/Nodata";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";
import { Link } from "react-router-dom";

function RegisterUserListAudition() {
  const { imageCdnUrl } = useContext(serverInfo);
  const [event, setEvent] = useState({});
  const [lives, setLives] = useState([]);
  const [auditionName, setAuditionName] = useState("");
  const [listView, setListView] = useState(false);
  const [buffer, setBuffer] = useState(true);
  const [participantList, setParticipantList] = useState([]);
  const [links, setLinks] = useState([]);

  useEffect(() => {
    axios.get("/api/audition-admin/audition/lives").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setLives(res.data.lives);
      }
    });
  }, []);

  const clickHandler = (id, name) => {
    axios.get(`/api/audition-admin/participant/list/${id}`).then((res) => {
      if (res.data.status === 200) {
        setListView(true);
        setAuditionName(name);
        setEvent(res.data.audition);
        setParticipantList(res.data.participantList.data);
        setLinks(res.data.participantList.links);
        console.log(res.data.participantList.links);
      }
    });
  };

  const tableHead = [
    "#SL",
    "Name",
    "Phone",
    "Email",
    "Audition Title",
    "Start - End",
    "React Marks",
    "Status",
  ];

  return (
    <>
      <AllDataHeader title="Register User List" image={cup} count={"Zero"} />

      {buffer ? (
        <LoaderPost />
      ) : (<>
      {lives.length !==0 ?
      <>
        
        <div className=" row p-2">
            {lives.map((event) => (
              <div className="p-3 col-md-3 mb-3">
                <div className="card card-bg completedMeetupBlack GoldBorder">
                  <img
                    src={imageCdnUrl+event.banner}
                    className="img-fluid p-2 ImgBlue"
                    alt=""
                    style={{
                      height: "200px",
                      width: "100%",
                    }}
                  />
                  <div className="p-3">
                    <center>
                      <h4 className="text-white text-center fw-bold title-limit">
                        <i>{event.title}</i>
                      </h4>

                      <Link to={`/audition-admin/audition/participant-list/${event.id}`}
                       className="btn btnConfirm w-100 fw-bold PTBDn px-5 py-2 mt-4"
                       >
                      Show
                    </Link>

                    {/* <button
                      className="btn btnConfirm w-100 fw-bold PTBDn px-5 py-2 mt-4"
                      onClick={() => clickHandler(event.id, event.title)}
                    >
                      Show
                    </button> */}
                  </center>
                </div>
              </div>
            </div>
          ))}
        </div>
       

        {/* {listView && (
          <RegisteredTable
            tableHead={tableHead}
            data={participantList}
            links={links}
            auditionName={auditionName}
          />
        )} */}
      </>
      :
      <Nodata/>
        }
      </>
       )}
      
    </>
  );
}

export default RegisterUserListAudition;
